import { post, get, put } from '@common/http'

// 获取商品*项目类别列表（不用分页）增删setting 通用接口
export const getGoodDict = param => get('/dict/list', param)

// 获取项目列表
export const getGoodPackageList = param => get(`/tenant-package/list`, param)

// 获取商品列表
export const getTenantProductList = param => get('/tenant-product/list', param)

// 获取门店未离职员工
export const acquireExistingEmployeesOfTheStore = param => get('/employee/list-by-sort?disabled=0')
// 获取所有跟进离职员工
export const getResignedEmployee = (param) => get(`/employee/getResignedEmployee`);
// 获取会员信息
export const getMemberInfoList = param => get('/member-base/queryList', param)

// 获取会员详情
export const getMemberParticulars = param => get('/member-base/get-memberCard-by-phone', param)

// 根据会员卡计算项目价格
/**
 * costPrice {Number}价格
 * employeeAppointDTOList {Array}员工列表
 * employeeAppointDTOList -> appoint {Number}是否指定 1指定 0非指定
 * employeeAppointDTOList -> employeeId {String}员工id
 * employeeAppointDTOList -> sell {String} 销售
 * employeeAppointDTOList -> work {String} 劳动
 * employeeAppointDTOList -> workType {String} 大工
 * itemId {String}项目id
 * itemType {Number}类型 0项目 1产品
 * manualOperation {String}四舍五入 0开启 1关闭
 * memberCardId {String}会员卡id
 * num {Number}产品&&项目数量
 * originPrice {Number} 原价
 * */
/**
 * @description:  根据会员卡计算项目价格
 * @param {*} param
 * @return {*}
 */
export const calculatingProjectAmount = param => post('/order/consume-brokerage', param)

// 订单结算
/**
 * chargeTime {String} 收款时间
 * consumeDTO {Array}
 * consumeDTO -> consumerItemDTOList {Array}项目列表
 *      consumeDTO -> consumerItemDTOList -> costPrice {Number}结算价格
 *      consumeDTO -> consumerItemDTOList -> employeeAppointDTOList {Array}员工
 *          consumeDTO -> consumerItemDTOList -> employeeAppointDTOList -> appoint {Number}是否指定 非指定
 *          consumeDTO -> consumerItemDTOList -> employeeAppointDTOList -> employeeId {String}员工id
 *          consumeDTO -> consumerItemDTOList -> employeeAppointDTOList -> sell {Number}销售业绩
 *          consumeDTO -> consumerItemDTOList -> employeeAppointDTOList -> work {Number}劳动业绩
 *          consumeDTO -> consumerItemDTOList -> employeeAppointDTOList -> workType {String}劳动类型
 *      consumeDTO -> consumerItemDTOList -> itemId {String}项目id
 *      consumeDTO -> consumerItemDTOList -> itemType {Number}项目0 产品1
 *      consumeDTO -> consumerItemDTOList -> num {Number}数量
 *      consumeDTO -> consumerItemDTOList -> originPrice {Float}原价
 *      consumeDTO -> freeAmount {Float} 优惠金额
 *      consumeDTO -> memberCardId {String} 会员卡id
 *      consumeDTO -> memberId {String} 会员id
 * consumeDTO -> costCardAmount {Number}
 * consumeDTO -> costCardTime {Number}
 * consumeDTO -> customerSex {String}性别
 * consumeDTO -> flag {Boolean}
 * consumeDTO -> freeAmount {Float} 优惠金额
 * consumeDTO -> orderType {Number} 订单类型 30会员消费 40散客消费
 * consumeDTO -> payCrashAmount {String}
 * consumeDTO -> payTypeDTOList {Array}支付方式列表
 *      consumeDTO -> payTypeDTOList -> amount {Float}支付金额
 *      consumeDTO -> payTypeDTOList -> payType {Number}支付类型
 *      consumeDTO -> payTypeDTOList -> payTypeName {String} 支付名称
 * consumeDTO -> payableAmount {Float}
 * consumeDTO -> remark {String} 流水单号
 * consumeDTO -> totalAmount {Float} // 订单总额
 * */
export const tallyOrder = param => post('/order', param)

/**
 * memberCardId 会员卡id
 * price 金额
 * employeeIds 员工id
 * */
export const rechargePerformanceCalculation = param => get('/order/recharge-brokerage', param)

// 获取会员卡
export const obtainMembershipCardList = param => get('/tenant-card/list', param)

// 获取门店个性次卡id
export const getPersonalityCardId = param => get('/t-tenant-individuality-card/getIndividualityCardId', param)

// 添加门店次卡id
export const postTenantCardOnegx = param => post('/t-tenant-individuality-card/addIndividualityCard', param)

// 计算个性次卡开卡业绩信息
export const calculateIndividualSubPerformance = param => get('/order/create-individuality-card-detail-and-brokerage', param)

// 店铺开卡
export const storeOpeningCard = param => post('/tenant-card/addForIndividuality', param)

// 个性次卡订单结算
export const individualSubCardOrderSettlement = param => post('/order/addForIndividuality', param)

// 添加会员信息
export const addMemberInformation = param => post('/member-base', param)

export const updateMemberData = param => put('/member-base', param)

// 会员开卡结算
export const membersOpenCardsToSettleOrders = param => post('/order', param)

// 挂单
/**
 * @description: 挂单 
 * @param {*} param costPrice originPrice
 * @return {*} 
 */
export const orderPlacement = param => post('/order/hangOrder', param)

// 获取挂单数据
export const obtainOrderingData = param => get('/order/page-with-detail', param)

// 获取当前店铺所有已被占用的手牌号
export const theNumberOfTheCurrentlyOccupiedHandObtained = param => post('/order/selectByHandBrandList', param)

// 合并挂单信息
export const mergeBillingInformation = param => post('/order/mergeOrder', param)

// 根据会员id获取会员信息
export const getInformationAccordingToTheMemberId = param => get(`/member-base/${param}`)

// 待付款结算
export const orderPendingPaymentSettlement = param => post('/order/webOrderPlease', param)

// 顾客扫码支付
export const wisdomPaysByCard = param => get('/order/createQrCodeOrderUrl', param)

// 获取门店权限信息
export const getStorePermissionInformation = param => get(`/user/permission/${param}`)

// 
/**
 * @description: 获取为占用手牌号
 * @param {*} param
 * @return {*}
 */
export const getAnUnoccupiedHan = param => post('/order/getHandBrand')

// 取消订单
export const cancellationOfOrder = param => put('/order', param)

// 更新卡信息
export const withTheNewCardInformation = param => post('/member-base/update_card', param)

// 更新挂单信息
export const updateHangOrderInfo = param => post('/order/updateHangOrder', param)

// 获取挂单单数
export const getPendingPaymentOrders = _ => get('/order/getPendingPaymentOrders')

// 获取员工权限信息
export const getEmployeePermissionInformation = param => get(`/employee/${param}/brokerage`)

// 获取门店员工业绩权限
export const accessToAllEmployeeCommissions = _ => get('/employee/accessToAllEmployeeCommissions')

// 监听字符串变化
export const monitorTheCompletionOfPaymentOrders = param => get(`/order/getLakalaOrderStatus?id=${param}`)

// 修改积分
export const manualModificationOfIntegral = param => get(`/t-member-points-flow-record/addPointFlowRecord?memberId=${param.memberId}&point=${param.point}&type=${param.type}`)

// 获取店铺全局设置
export const getStoreGlobalSetting = param => get('/dict?dict_type=DT_002')

// 通过手牌号id
export const getByIdHandBrand = param => get(`/dict/getByIdHandBrand?id=${param}`)

export const createCardDetailAndBrokerage = param => get('/order/create-card-detail-and-brokerage', param)

export const putErrorContent = param => post('/tenantError/add', param)



// WEBPACK FOOTER //
// ./src/api/paperless.js